var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-ring v-ring1",style:(_vm.spinnerBasicStyle)},[_c('div',{staticClass:"v-ring v-ring2",style:(_vm.spinnerStyle)}),_vm._v(" "),_c('div',{staticClass:"v-ring v-ring3",style:(_vm.spinnerStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f4b13e6","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/cross-components/ring-loader.vue
// module id = 613
// module chunks = 0